export const UNSELECTED_SUB_ACCOUNT = '';

// key needs to match what is in index.html
export const CLIENT_TITLE_KEY = 'client-title';

// key needs to match what is in index.html
export const CLIENT_FAVICON_KEY = 'client-favicon-path';
